import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import * as TimeseriesActionCreators from '../../actions/timeseries'

import { timeseriesConfig } from '../../utils/TimeseriesConfig'

class UnitTimeseriesValueContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    timeseriesName: PropTypes.string.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static styles = {}

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { unitId, timeseriesActions } = this.props
    timeseriesActions.listUnitTimeseries(unitId)
  }

  timeseries() {
    const {
      unitId, timeseriesName, timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[unitId] || []

    return tsIds.map((id) => (timeseries[id])).find((ts) => ts.name === timeseriesName)
  }

  render() {
    const ts = this.timeseries()
    if (ts && ts.name && ts.current_value && ts.current_value.value != null) {
      const tsConfig = timeseriesConfig(ts.name)
      return (
        tsConfig.format(ts.current_value.value)
      )
    }
    return null
  }
}

export default connect(
  UnitTimeseriesValueContainer.mapStateToProps,
  UnitTimeseriesValueContainer.mapDispatchToProps,
)(withStyles(UnitTimeseriesValueContainer.styles)(UnitTimeseriesValueContainer))
